@import 'styles/mixins';
@import 'styles/variables';

.wrapper {
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: center;

  .indicator {
    margin: 0;
  }
}
